import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/* Wraps any route that requires an authenticated user.
 * - user === null -> still checking (full-screen loader)
 * - user === false -> redirect to /academy/login
 * - user object & roles match -> render children */
export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen bg-[#0e0e10] flex items-center justify-center">
        <div className="text-[#c9a227] animate-pulse text-sm tracking-[0.3em] uppercase font-bold">Loading…</div>
      </div>
    );
  }
  if (user === false) {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/academy/login?next=${next}`} replace />;
  }
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/academy/dashboard" replace />;
  }
  return children;
}
